enum RealTimeNotificationCategory {
  variable = "variable"
}

export default RealTimeNotificationCategory;
